(function () {
  function init(root) {
    var track = root.querySelector('[data-track]');
    var dots = root.querySelector('[data-dots]');
    if (!track || !dots || !track.children.length) return;
    var cards = track.children;
    function cardWidth() { return cards[0].getBoundingClientRect().width + 28; }
    function perView() { return Math.max(1, Math.round(track.clientWidth / cards[0].getBoundingClientRect().width)); }
    function update() {
      var i = Math.round(track.scrollLeft / cardWidth());
      var n = dots.children.length;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === Math.min(i, n - 1)); });
    }
    function build() {
      dots.innerHTML = '';
      var pages = Math.max(1, cards.length - perView() + 1);
      Array.from({ length: pages }).forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Avis ' + (i + 1));
        b.addEventListener('click', function () {
          track.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      update();
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    window.addEventListener('resize', build);
    build();
  }
  function run() { document.querySelectorAll('[data-blzrs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
